.card {
	border: 1px solid var(--border-primary);
	border-radius: 12px;
	background-color: var(--background-primary);
	transition: border-color 200ms ease;
}

/* Only the header toggles the card, so only hovering it gets the affordance. */
.card:has(.header[data-hovered]) {
	border-color: var(--border-hover);
}

.expanded {
	border-color: var(--border-hover);
}

.header {
	all: unset;
	box-sizing: border-box;
	cursor: pointer;
	width: 100%;
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 16px;
	text-align: left;
}

.summary {
	padding: 0 16px 16px;
}

.header[data-focus-visible] {
	outline: var(--focus-outline);
	border-radius: 12px;
}

.text {
	display: flex;
	flex-direction: column;
	gap: 4px;
	flex: 1;
	min-width: 0;
}

.title {
	color: var(--content-primary);
}

.description {
	color: var(--content-tertiary);
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	overflow-wrap: anywhere;
}

.chevron {
	flex-shrink: 0;
	color: var(--content-tertiary);
	transition: transform 200ms ease;
}

.chevronExpanded {
	transform: rotate(180deg);
}

.panel {
	display: flex;
	flex-direction: column;
	gap: 12px;
	/* The collapsible clips overflow; the top padding keeps the 2px focus outline
	   of the first field from being cut off. */
	padding: 4px 16px 16px;
}
